// #region module
export const tau = Math.PI * 2;
// #endregion module
